import "@dxos/node-std/globals";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x + '" is not supported');
});
var __commonJS = (cb, mod) => function __require2() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// src/common/utils.ts
import { join } from "@dxos/node-std/path";
var stringDiff = (first, second) => first.split(second).join("");
var getFullPath = (root, path) => join(root, stringDiff(path, root));

// src/common/directory.ts
var Directory = class _Directory {
  type;
  path;
  // TODO(burdon): Create interface for these methods (shared with AbstractStorage).
  _list;
  _getOrCreateFile;
  _remove;
  _onFlush;
  constructor({ type, path, list, getOrCreateFile, remove, onFlush }) {
    this.type = type;
    this.path = path;
    this._list = list;
    this._getOrCreateFile = getOrCreateFile;
    this._remove = remove;
    this._onFlush = onFlush;
  }
  toString() {
    return `Directory(${JSON.stringify({
      type: this.type,
      path: this.path
    })})`;
  }
  /**
  * Create a new sub-directory.
  */
  createDirectory(path) {
    return new _Directory({
      type: this.type,
      path: getFullPath(this.path, path),
      list: this._list,
      getOrCreateFile: this._getOrCreateFile,
      remove: this._remove
    });
  }
  /**
  * Get all files in the current directory.
  */
  list() {
    return this._list(this.path);
  }
  /**
  * Get or create a new file.
  */
  getOrCreateFile(filename, opts) {
    return this._getOrCreateFile(this.path, filename, opts);
  }
  async flush() {
    await this._onFlush?.();
  }
  /**
  * Close and delete all files in the directory and all its sub-directories.
  */
  async delete() {
    await this._remove();
  }
};

// src/common/file.ts
import pify from "pify";
import { log } from "@dxos/log";
var __dxlog_file = "/__w/dxos/dxos/packages/common/random-access-storage/src/common/file.ts";
var MAX_STORAGE_OPERATION_TIME = 50;
var pifyFields = (object, type, fields) => {
  for (const field of fields) {
    if (!object[field]) {
    } else {
      const fn = pify(object[field].bind(object));
      object[field] = async (...args) => {
        const before = performance.now();
        const res = await fn(...args);
        const elapsed = performance.now() - before;
        if (elapsed > MAX_STORAGE_OPERATION_TIME) {
          log("Slow storage operation", {
            type,
            operation: field,
            elapsed
          }, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 19, S: void 0 });
        }
        return res;
      };
    }
  }
  return object;
};
var wrapFile = (native, type) => {
  const file = pifyFields(native, type, [
    "write",
    "read",
    "del",
    "stat",
    "close",
    "destroy",
    "truncate"
  ]);
  return Object.assign(file, {
    type,
    native
  });
};

// src/common/abstract-storage.ts
import { join as join2 } from "@dxos/node-std/path";
import { inspect } from "@dxos/node-std/util";
import { inspectObject } from "@dxos/debug";
import { log as log2 } from "@dxos/log";
var __dxlog_file2 = "/__w/dxos/dxos/packages/common/random-access-storage/src/common/abstract-storage.ts";
var AbstractStorage = class {
  path;
  _files = /* @__PURE__ */ new Map();
  // TODO(burdon): Make required.
  constructor(path) {
    this.path = path;
  }
  [inspect.custom]() {
    return inspectObject(this);
  }
  toJSON() {
    return {
      type: this.type,
      path: this.path
    };
  }
  get size() {
    return this._files.size;
  }
  // TODO(burdon): Make required.
  createDirectory(sub = "") {
    return new Directory({
      type: this.type,
      path: getFullPath(this.path, sub),
      list: this._list.bind(this),
      getOrCreateFile: (...args) => this.getOrCreateFile(...args),
      remove: () => this._remove(sub)
    });
  }
  /**
  * Delete all files.
  */
  async reset() {
    try {
      log2.info("Erasing all data...", void 0, { "~LogMeta": "~LogMeta", F: __dxlog_file2, L: 50, S: this });
      await this._closeFilesInPath("");
      await this._remove("");
      await this._destroy();
      log2("Erased...", void 0, { "~LogMeta": "~LogMeta", F: __dxlog_file2, L: 54, S: this });
    } catch (err) {
      log2.catch(err, void 0, { "~LogMeta": "~LogMeta", F: __dxlog_file2, L: 56, S: this });
    }
  }
  async _list(path) {
    return Array.from((await this._getFiles(path)).keys()).map((filename) => {
      let name = filename.replace(path, "");
      if (name.startsWith("/")) {
        name = name.substring(1);
      }
      return name;
    });
  }
  getOrCreateFile(path, filename, opts) {
    const fullPath = join2(path, filename);
    let native;
    let file = this._getFileIfExists(fullPath);
    if (file) {
      if (!file.closed) {
        return file;
      }
      native = this._openFile(file.native);
    }
    if (!native) {
      native = this._createFile(path, filename, opts);
    }
    file = wrapFile(native, this.type);
    this._files.set(fullPath, file);
    return file;
  }
  _destroy() {
    return void 0;
  }
  /**
  * Attempt to reopen file.
  */
  _openFile(file) {
    return void 0;
  }
  _getFileIfExists(filename) {
    if (this._files.has(filename)) {
      const file = this._files.get(filename);
      if (file && !file.destroyed) {
        return file;
      }
    }
  }
  async _getFiles(path) {
    const fullPath = getFullPath(this.path, path);
    return new Map([
      ...this._files.entries()
    ].filter(([path2, file]) => path2.includes(fullPath) && file.destroyed !== true));
  }
  async _closeFilesInPath(path) {
    await Promise.all(Array.from((await this._getFiles(path)).values()).map((file) => file.close().catch((err) => log2.catch(err, void 0, { "~LogMeta": "~LogMeta", F: __dxlog_file2, L: 109, S: this }))));
  }
  async close() {
    await this._closeFilesInPath("");
  }
  // TODO(burdon): Delete directory (not just listed files).
  async _remove(path) {
    await Promise.all(Array.from(await this._getFiles(path)).map(([path2, file]) => {
      return file.destroy().then(() => this._files.delete(path2)).catch((err) => log2.error(err.message, void 0, { "~LogMeta": "~LogMeta", F: __dxlog_file2, L: 117, S: this }));
    }));
  }
};

// src/common/storage.ts
var StorageType = /* @__PURE__ */ (function(StorageType2) {
  StorageType2["RAM"] = "ram";
  StorageType2["IDB"] = "idb";
  StorageType2["CHROME"] = "chrome";
  StorageType2["FIREFOX"] = "firefox";
  StorageType2["NODE"] = "node";
  StorageType2["WEBFS"] = "webfs";
  return StorageType2;
})({});

// src/common/memory-storage.ts
import ram from "random-access-memory";
import { arrayToBuffer } from "@dxos/util";
var MemoryStorage = class extends AbstractStorage {
  type = StorageType.RAM;
  _createFile(path, filename) {
    return this._patchFile(ram());
  }
  _openFile(file) {
    const newFile = file.clone();
    newFile.closed = false;
    return this._patchFile(newFile);
  }
  _patchFile(file) {
    const trueRead = file.read.bind(file);
    file.read = (offset, size, cb) => trueRead(offset, size, (err, data) => {
      if (err) {
        return cb(err);
      } else {
        return cb(err, arrayToBuffer(data));
      }
    });
    return file;
  }
  async getDiskInfo() {
    let used = 0;
    for (const file of this._files.values()) {
      const size = file.length;
      used += Number.isNaN(size) ? 0 : size;
    }
    return {
      used
    };
  }
};

export {
  __require,
  __commonJS,
  __toESM,
  stringDiff,
  getFullPath,
  Directory,
  wrapFile,
  AbstractStorage,
  StorageType,
  MemoryStorage
};
//# sourceMappingURL=chunk-FZVWJO4G.mjs.map
